<template>
  <div v-if="showPager" class="admin-pagination">
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeOptions"
      @current-change="onPageChange"
      @size-change="onSizeChange"
    />
  </div>
</template>

<script>
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from '../utils/pagination'

export default {
  name: 'AdminPagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: DEFAULT_PAGE_SIZE
    },
    pageSizeOptions: {
      type: Array,
      default() {
        return PAGE_SIZE_OPTIONS.slice()
      }
    },
    hideOnEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showPager() {
      if (this.hideOnEmpty && !this.total) return false
      return true
    }
  },
  methods: {
    onPageChange(nextPage) {
      this.$emit('update:page', nextPage)
      this.$emit('change', { page: nextPage, pageSize: this.pageSize })
    },
    onSizeChange(nextSize) {
      this.$emit('update:pageSize', nextSize)
      this.$emit('update:page', 1)
      this.$emit('change', { page: 1, pageSize: nextSize })
    }
  }
}
</script>

<style scoped>
.admin-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.admin-pagination ::v-deep .el-pagination {
  padding: 0;
  font-weight: normal;
}

.admin-pagination ::v-deep .el-pagination__total {
  color: #64748b;
}

.admin-pagination ::v-deep .el-pagination.is-background .btn-next,
.admin-pagination ::v-deep .el-pagination.is-background .btn-prev,
.admin-pagination ::v-deep .el-pagination.is-background .el-pager li {
  border-radius: 8px;
}
</style>
